import { ArrowDownwardSharp } from "@mui/icons-material";
import { CircularProgress, IconButton, Popover, TextField } from "@mui/material";
import axios from "axios";
import React, { useState, useRef } from "react";
import { request } from '../../../request';

const RegeratePopoverForm = ({ anchorEl, open, onClose, oldData, updateContent, userInputData, sectionName, contentKey }) => {

    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const handleSubmit = async (event) => {
        const otherPayload = {
            oldData: oldData,
            subPrompt: inputValue,
            sectionName: sectionName,
            fieldName: contentKey

        };
        setLoading(true)
        const url = process.env.REACT_APP_STUDIO_BACKEND_API_URL + "v1/templates/app-template/generate-bestpractices-content";
        const resp = await request.create({
            endPoint: url,
            jsonData: {
                actionType: "REGENERATE",
                userFormPayload: JSON.stringify(userInputData, null, 2),
                otherPayload: JSON.stringify(otherPayload,null,2)
            }
        }
          )
          setLoading(false);
          if(typeof resp === "undefined")
            {
              setError(true);
              console.log("Error while calling API : ", error)
            }else{

                //console.log("Regenerate response data", resp);
                const content =  resp?.content?.result
                updateContent(content);
                onClose();
            }

        // setTimeout(() => {
        //     setLoading(false);
        //     console.log("User input data -> ",userInputData);
        //     console.log("section name -> ",sectionName);
        //     updateContent(inputValue);
        //     onClose();
        // }, 2000);

    }

    const handleChange = (event) => {
        setInputValue(event.target.value);
    };
    //const open = Boolean(anchorChildEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
        >
            <div style={{ padding: '20px', display: "flex" }}>
                <TextField
                    label="Enter Text"
                    variant="outlined"
                    fullWidth
                    value={inputValue}
                    onChange={handleChange}
                />
                {!loading && <IconButton color="primary" onClick={handleSubmit}>
                    <ArrowDownwardSharp />
                </IconButton>}
                {loading && (
                    <CircularProgress
                        size={24} // Size of the spinner
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '80%',
                            marginTop: '-12px', // Half of spinner size to center it
                            marginLeft: '-12px',
                        }}
                    />
                )}
            </div>
        </Popover>
    );
};


export default RegeratePopoverForm;